const types = {
    TOC_SET_QUESTIONS_INDEX: 'TOC_SET_QUESTIONS_INDEX',
    TOC_SET_FILTER: 'TOC_SET_FILTER',
};

const filterTypes = {
    ALL: 'ALL',
    FLAGGED: 'FLAGGED',
    NOT_ATTEMPTED: 'NOT_ATTEMPTED',
    MANUALLY_SELECTED: 'MANUALLY_SELECTED',
    MANUALLY_SELECTED_NOT_ATTEMPTED: 'MANUALLY_SELECTED_NOT_ATTEMPTED',
};

const tocActions = {
    types,
    filterTypes,

    setQuestionsIndex(questionsIndex) {
        return { type: types.TOC_SET_QUESTIONS_INDEX, questionsIndex };
    },

    setFilter(filter) {
        return { type: types.TOC_SET_FILTER, filter };
    },
};

export default tocActions;
